<template>
  <footer class="app-footer">
    <div class="footer-content">
      <p class="copyright">
        © 2019 - {{ currentYear }}   菩提智慧   版权所有
      </p>
      <div class="record-info">
        <a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener noreferrer">
          陕ICP备2025082273号-1
        </a>
        <span class="separator"> | </span>
        <a href="https://www.beian.gov.cn/portal/registerSystemInfo" target="_blank" rel="noopener noreferrer">
          陕公网安备xxxxxxxx号
        </a>
      </div>
    </div>
  </footer>
</template>

<script setup>
import { ref } from 'vue'

const currentYear = ref(new Date().getFullYear())
</script>

<style scoped>
.app-footer {
  background-color: #f8f9fa;
  padding: 20px 0;
  border-top: 1px solid #e9ecef;
  margin-top: auto;
}

.footer-content {
  max-width: 1200px;
  margin: 0 auto;
  text-align: center;
  padding: 0 20px;
}

.copyright {
  margin: 0 0 10px 0;
  color: #6c757d;
  font-size: 14px;
}

.record-info {
  font-size: 12px;
  color: #6c757d;
}

.record-info a {
  color: inherit;
  text-decoration: none;
  transition: color 0.3s ease;
}

.record-info a:hover {
  color: #007bff;
  text-decoration: underline;
}

.separator {
  margin: 0 8px;
  color: #dee2e6;
}
</style>